
let imageDB = null;

export const createLocalDB = (dbName) =>{
    const indexedDB =
    window.indexedDB ||
    window.mozIndexedDB ||
    window.webkitIndexedDB ||
    window.msIndexedDB ||
    window.shimIndexedDB;

  if (!indexedDB) {
  console.error("IndexedDB could not be found in this browser.");
  }
   let mf_IDB =  indexedDB.open(dbName, 1);
    mf_IDB.onerror = function (event) {
    console.error("An error occurred with IndexedDB:" + event);
    };
    mf_IDB.onupgradeneeded = (event) => {
      const dbInit = mf_IDB.result;
      // create the Contacts object store 
      // with auto-increment id
      if(!dbInit.objectStoreNames.contains('MF_Image')){
        dbInit.createObjectStore('MF_Image',{
          keyPath:"key"
        });
      }
    };
  
 

mf_IDB.onsuccess = (event) => {
};
  // db.close()
}

export const addImageLocalDB = async (fileKey,blob) => {
  let mf_IDB_add =  indexedDB.open("mf_inDB", 1)
  mf_IDB_add.onerror = function (event) {
    console.error("An error occurred with IndexedDB:" + event);
  };

  mf_IDB_add.onupgradeneeded = (event) => {
    const db_add_0 = mf_IDB_add.result;
    // create the Contacts object store 
    // with auto-increment id
    if(!db_add_0.objectStoreNames.contains('MF_Image')){
     db_add_0.createObjectStore('MF_Image',{
        keyPath:"key"
      });
    }
  };
  
  
  mf_IDB_add.onsuccess = () => {
    const db_add = mf_IDB_add.result;

    let tx = db_add.transaction("MF_Image", "readwrite");
    let imageData = tx.objectStore("MF_Image");
      let blobData = { 
        "key":fileKey,"blob":blob
      } 
      const updatedImageData = imageData.put(blobData)
      updatedImageData.onsuccess = (query) => {
        tx.oncomplete = function () {
          db_add.close();
        };
      };
  };

}

export const checkBlob = (keyString) => {
    const dbPromise = indexedDB.open("mf_inDB", 1);
    dbPromise.onerror = function (event) {
      console.error("An error occurred with IndexedDB:" + event);
    };
  
    dbPromise.onupgradeneeded = (event) => {
      let db_check = dbPromise.result;
      // create the Contacts object store 
      // with auto-increment id
      if(!db_check.objectStoreNames.contains('MF_Image')){
        db_check.createObjectStore('MF_Image',{
          keyPath:"key"
        });
      }
    };

    dbPromise.onsuccess = () => {
    const db_check = dbPromise.result;

    let tx = db_check.transaction("MF_Image", "readonly");
    let mfImage = tx.objectStore("MF_Image");
    const checkImageBlob = mfImage.getAll();

   checkImageBlob.onsuccess = (query) => {
      // imageDB = query.srcElement.result
      imageDB = query.target.result
    };
    
    tx.oncomplete = function () {
      db_check.close();
    };
  };
  return returnBlob(imageDB,keyString)
  }
  
export const returnBlob = (ImageDB,keyString) => {
  if(ImageDB){
    const imageBlob = ImageDB.filter(ele=>ele.key === keyString)[0]
    return imageBlob?.blob
  }
}

export const deleteDatabase = () => {
  let req = indexedDB.deleteDatabase("mf_inDB");
  req.onsuccess = function () {
      console.log("Deleted database successfully");
  };
  req.onerror = function () {
      console.log("Couldn't delete database");
  };
  req.onblocked = function () {
      console.log("Couldn't delete database due to the operation being blocked");
  };
}